/**
 * Parse a multi-select filter value from URL into a number array.
 * Chips encode multi-select as comma-separated string ("5,6"); single value is "5".
 * Returns undefined when the filter is empty or contains no valid numbers.
 */
export function parseEnumListFilter(value: unknown): number[] | undefined {
  if (value == null || value === "") return undefined;
  const raw = Array.isArray(value) ? value : String(value).split(",");
  const nums = raw.map((v) => Number(v)).filter((n) => Number.isFinite(n));
  return nums.length ? nums : undefined;
}
